import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'unity-switch',
  templateUrl: './unity-switch.component.html',
  styleUrls: ['./unity-switch.component.scss']
})
export class UnitySwitchComponent implements OnInit {
  @Input() classes: string;
  @Input() inputId: string;
  @Input() isChecked: boolean = false;
  @Input() label: string;
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() checkboxChange = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onCheckboxChange(e: Event) {
    if (this.disabled !== true) {
      this.checkboxChange.emit(e);
    }
  }
}
